import { axiosInstance } from ".."

const validateUser = async () =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.get(`internal/Me`).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default validateUser;